module.exports = __webpack_public_path__ + "static/img/Gold.c979933.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/vip/Gold.svg
// module id = LLGK
// module chunks = 1